import React, { useContext } from 'react';

import { StyleSheet, TouchableHighlight, View } from 'react-native';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { States } from '../types/props';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { useDyteSelector } from '@dytesdk/react-native-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  size,
  states,
  variant,
  iconPack = defaultIconPack,
  t,
}: {
  size?: 'lg' | 'md' | 'sm' | 'xl';
  states?: States;
  variant?: 'button' | 'horizontal';
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const self = useDyteSelector((m) => m.self);
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  let buttonSize = 25;
  let buttonHorizontal = false;
  switch (size) {
    case 'md':
      buttonSize = 50;
      break;
    case 'lg':
      buttonSize = 100;
      break;
    case 'xl':
      buttonSize = 150;
      break;
  }
  switch (variant) {
    case 'horizontal':
      buttonHorizontal = true;
      break;
  }
  const styles = StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    horizontalButton: {
      height: buttonSize * 2,
      width: '100%',
      backgroundColor: colors.background[1000],
    },
    button: {
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    buttonWrapper: {
      flexDirection: 'row',
      width: '100%',
      paddingVertical: 12,
      paddingLeft: 48,
    },
    settingsText: {
      paddingHorizontal: 18,
      color: colors.text,
    },
    settingsIcon: {
      flexDirection: 'row',
      padding: 12,
      borderRadius: 4,
    },
  });
  if (
    self.mediaPermissions.audio !== 'ACCEPTED' &&
    self.mediaPermissions.video !== 'ACCEPTED'
  )
    return null;
  return (
    <View style={styles.container}>
      {buttonHorizontal && (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({
              ...states,
              activeSettings: !states.activeSettings,
              activeMoreMenu: false,
            });
          }}
          style={styles.horizontalButton}
        >
          <View style={styles.buttonWrapper}>
            <SvgXml
              xml={iconPack.settings.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
            <DyteText style={styles.settingsText}>{t('settings')}</DyteText>
          </View>
        </TouchableHighlight>
      )}
      {!buttonHorizontal && (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({
              ...states,
              activeSettings: !states.activeSettings,
              activeMoreMenu: false,
            });
          }}
          style={styles.button}
        >
          <View style={styles.settingsIcon}>
            <SvgXml
              xml={iconPack.settings.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
          </View>
        </TouchableHighlight>
      )}
    </View>
  );
}
